namespace ui
{

	export function a(): HTMLAnchorElement { return document.createElement( 'a' ); }
	export function i(): HTMLElement { return document.createElement( 'i' ); }
	export function p(): HTMLParagraphElement { return document.createElement( 'p' ); }
	export function br(): HTMLBRElement { return document.createElement( 'br' ); }
	export function hr(): HTMLHRElement { return document.createElement( 'hr' ); }
	export function ol(): HTMLOListElement { return document.createElement( 'ol' ); }
	export function ul(): HTMLUListElement { return document.createElement( 'ul' ); }
	export function li(): HTMLLIElement { return document.createElement( 'li' ); }
	export function div(): HTMLDivElement { return document.createElement( 'div' ); }
	export function img(): HTMLImageElement { return document.createElement( 'img' ); }
	export function nav(): HTMLElement { return document.createElement( 'nav' ); }
	export function pre(): HTMLPreElement { return document.createElement( 'pre' ); }
	export function span(): HTMLSpanElement { return document.createElement( 'span' ); }
	export function iframe(): HTMLIFrameElement { return document.createElement( 'iframe' ); }
	export function treenode(): HTMLElement { return document.createElement( 'node' ); }
	export function treeleaf(): HTMLElement { return document.createElement( 'leaf' ); }
	export function treeicon(): HTMLElement { return document.createElement( 'icon' ); }
	export function input(): HTMLElement { return document.createElement( 'input' ); }
	export function label(): HTMLLabelElement { return document.createElement( 'label' ); }
	export function canvas(): HTMLCanvasElement { return document.createElement( 'canvas' ); }
	export function address(): HTMLElement { return document.createElement( 'address' ); }
	export function button(): HTMLButtonElement { return document.createElement( 'button' ); }
	export function text( text_: string ): Text { return document.createTextNode( text_ ); }

	export function h(
		extend: number,
		content: string | Text[] | HTMLElement[] | Array<JQuery<HTMLElement>>
	): HTMLElement
	{
		return $$.h( extend, content )[ 0 ];
	}

	export namespace $$
	{
		export function a(): JQuery { return $( ui.a() ); }
		export function i(): JQuery { return $( ui.i() ); }
		export function p(): JQuery { return $( ui.p() ); }
		export function br(): JQuery { return $( ui.br() ); }
		export function hr(): JQuery { return $( ui.hr() ); }
		export function ol(): JQuery { return $( ui.ol() ); }
		export function ul(): JQuery { return $( ui.ul() ); }
		export function li(): JQuery { return $( ui.li() ); }
		export function div(): JQuery { return $( ui.div() ); }
		export function img(): JQuery { return $( ui.img() ); }
		export function nav(): JQuery { return $( ui.nav() ); }
		export function pre(): JQuery { return $( ui.pre() ); }
		export function span(): JQuery { return $( ui.span() ); }
		export function iframe(): JQuery { return $( ui.iframe() ); }
		export function treenode(): JQuery { return $( ui.treenode() ); }
		export function treeleaf(): JQuery { return $( ui.treeleaf() ); }
		export function treeicon(): JQuery { return $( ui.treeicon() ); }
		export function input(): JQuery { return $( ui.input() ); }
		export function label(): JQuery { return $( ui.label() ); }
		export function canvas(): JQuery { return $( ui.canvas() ); }
		export function address(): JQuery { return $( document.createElement( 'address' ) ); }
		export function button(): JQuery { return $( document.createElement( 'button' ) ); }
		// @ts-ignore
		export function text( text_: string ): JQuery { return $( ui.text( text_ ) ); }

		export function h( extend: number, content: string | Text[] | HTMLElement[] | JQuery[]  ): JQuery
		{
			const h_: JQuery< HTMLElement > = $( document.createElement( 'h' + extend ) );

			if ( typeof content === 'string' )
			{
				h_.text( content );
			}
			else
			{
				for ( const c_ in content )
				{
					if ( content[ c_ ] )
					{
						h_.append( content[ c_ ] );
					}
				}
			}

			return h_;
		}
	}
}
